import React from 'react';
import useUser from './hooks/useUser';
import { useNavigate } from 'react-router-dom';
import LoadingPage from '@/pages/LoadingPage';

export default ({children}) => {
  const {isLogin} = useUser();
  const navigate = useNavigate();

  if (!isLogin) {
    navigate('/');
  }

  return children;
}

export const ProtectedAdminRoute = ({children}) => {
  const {isAdmin, isLogin} = useUser();
  const navigate = useNavigate();

  if (!isLogin) {
    navigate('/');
  }

  return (
    <>
      {isAdmin && children}
      {!isAdmin && <LoadingPage />}
    </>
  )
}
